
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.262 4.418l-5.17 3.04a1.056 1.056 0 00-.544.945l-.06 6.005h0v.005c0 .087.02.225.12.353a.55.55 0 00.281.191.57.57 0 00.47-.053l5.202-3.018h0l.006-.003c.345-.207.538-.54.538-.944h0l-.843-6.52zm0 0a.6.6 0 01.42-.076c.167.031.303.135.38.277a.617.617 0 01.073.296v.003l-.03 6.02-.843-6.52zM6.862.633l.012-.007.012-.008A.687.687 0 017.262.5c.1 0 .149.027.189.067L1.356 4.081a1.473 1.473 0 00-.33.237.902.902 0 00-.23.393c-.037.13-.049.27-.049.403v7.045c-.043-.01-.079-.036-.12-.094l-.406.293.406-.293C.558 11.97.5 11.813.5 11.55V4.93c0-.268.017-.44.039-.534a.232.232 0 01.075-.127l-.333-.364.333.364a2.9 2.9 0 01.45-.31L6.86.634zM4.155 5.707h0l-.007.004c-.112.067-.221.142-.309.225a.85.85 0 00-.24.407 1.6 1.6 0 00-.041.395v7.044c-.037-.01-.075-.036-.123-.101-.074-.1-.132-.254-.132-.508v-6.62c0-.267.018-.44.04-.539a.233.233 0 01.075-.128c.077-.07.217-.171.44-.302h.002L9.663 2.25l.001-.001a.83.83 0 01.402-.126c.093 0 .145.023.187.061L4.156 5.707zm9.24-1.035h0l.015 6.295s0 0 0 0c0 .243-.026.422-.066.548a.729.729 0 01-.173.296 1.938 1.938 0 01-.426.317l-5.458 3.135h-.001c-.317.18-.536.237-.674.237-.124 0-.18-.036-.234-.119-.076-.117-.145-.336-.145-.717V8.376c0-.244.026-.423.064-.549a.746.746 0 01.171-.298l-.366-.34.366.34a1.7 1.7 0 01.422-.31h0l.009-.004 5.459-3.157s0 0 0 0c.307-.176.519-.23.652-.23.12 0 .181.036.24.122.073.107.146.323.146.722z","fill":"#000","stroke":"#108999"}})])
          )
        }
      }
    